import { useTranslation } from "react-i18next";

interface ProgressBarProps {
  current: number;
  total: number;
}

export function ProgressBar({ current, total }: ProgressBarProps) {
  const { t } = useTranslation();
  const percent = Math.min(100, Math.max(0, (current / total) * 100));

  return (
    <div className="w-full">
      <p className="mb-2 text-caption text-muted">{t("wizard.step", { current, total })}</p>
      <div className="h-1 w-full overflow-hidden rounded-pill bg-border">
        <div
          className="h-full rounded-pill bg-signal transition-all duration-page ease-out"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={current}
          aria-valuemin={0}
          aria-valuemax={total}
        />
      </div>
    </div>
  );
}
